/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  mailSubject = '',
  templateParams,
  // Diz ao servidor que ESTA mensagem carrega a assinatura. Quem decide se
  // existe assinatura, qual e e onde entra, e o servidor — ver
  // `Messages::SignatureService`.
  applySignature = false,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    if (applySignature) {
      payload.append('apply_signature', true);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (mailSubject) {
      payload.append('mail_subject', mailSubject);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      mail_subject: mailSubject,
      template_params: templateParams,
      apply_signature: applySignature,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    mailSubject = '',
    templateParams,
    applySignature,
    // Support for snake_case properties from pendingMessage
    conversation_id,
    content,
    template_params,
    apply_signature,
  }) {
    // Map snake_case to camelCase if needed
    const finalConversationId = conversationId || conversation_id;
    const finalMessage = message || content;
    const finalTemplateParams = templateParams || template_params;

    return axios({
      method: 'post',
      url: `${this.url}/${finalConversationId}/messages`,
      data: buildCreatePayload({
        message: finalMessage,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        mailSubject,
        templateParams: finalTemplateParams,
        applySignature: applySignature || apply_signature || false,
      }),
    });
  }

  delete(conversationId, messageId) {
    return axios.delete(
      `${this.url}/${conversationId}/messages/${messageId}`
    );
  }

  getPreviousMessages({ conversationId, before, after }) {
    return axios.get(`${this.url}/${conversationId}/messages`, {
      params: { before, after },
    });
  }

  getMessage(conversationId, messageId) {
    return axios.get(`${this.url}/${conversationId}/messages/${messageId}`);
  }

  vote(conversationId, messageId, selectedOptions) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/vote`,
      {
        selected_options: selectedOptions,
      }
    );
  }

  toggleReaction(conversationId, messageId, reaction) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/toggle_reaction`,
      {
        reaction,
      }
    );
  }

  updateMessage(
    conversationId,
    messageId,
    { content, attachments, attachmentsToRemove }
  ) {
    if (attachments && attachments.length > 0) {
      const formData = new FormData();
      formData.append('content', content);
      attachments.forEach(file => {
        formData.append('attachments[]', file);
      });
      if (attachmentsToRemove && attachmentsToRemove.length > 0) {
        attachmentsToRemove.forEach(id => {
          formData.append('attachments_to_remove[]', id);
        });
      }
      return axios.put(
        `${this.url}/${conversationId}/messages/${messageId}`,
        formData
      );
    }
    return axios.put(`${this.url}/${conversationId}/messages/${messageId}`, {
      content,
      attachments_to_remove: attachmentsToRemove,
    });
  }

  deleteAttachment(conversationId, attachmentId) {
    return axios.delete(
      `${this.url}/${conversationId}/attachments/${attachmentId}`
    );
  }

  forwardMessage(conversationId, messageId, contacts) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/forward`,
      {
        contacts,
      }
    );
  }
}

export default new MessageApi();
